import { useEffect } from "react";

import { identifyGroups, identifyUser } from "@/lib/analytics";
import { useGlobalStore } from "@/stores/global";

/**
 * Identifies with the internal user id, not the Clerk id - the backend captures
 * with the same id, and mismatching the two splits one person in half.
 */
export const useAnalyticsIdentity = (): void => {
  const { loggedInUser, organization, activeWorkspace } = useGlobalStore();

  useEffect(() => {
    if (!loggedInUser) return;

    identifyUser({
      userId: loggedInUser.id,
      clerkUserId: loggedInUser.externalId,
      email: loggedInUser.email,
      name: `${loggedInUser.firstName} ${loggedInUser.lastName}`.trim(),
      role: loggedInUser.role,
    });
  }, [loggedInUser]);

  useEffect(() => {
    if (!organization || !activeWorkspace) return;

    identifyGroups({
      organizationId: organization.id,
      organizationName: organization.name,
      organizationType: organization.type,
      workspaceId: activeWorkspace.id,
      workspaceName: activeWorkspace.name,
    });
  }, [organization, activeWorkspace]);
};
